module.exports = __webpack_public_path__ + "static/img/0.cbd37cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/0.png
// module id = cCCx
// module chunks = 12